<i18n src="../../locales/lang.json"></i18n>

<template>
  <div id="quicklinkMenu" class="quicklink-menu">
    <nested-menu v-bind:isroot="true" @onclick="doClick" v-bind:parentexpanded="false" ref="nestedMenu" style="position:absolute;"></nested-menu>
  </div>
  
</template>

<script>
  
  var menu = [];

  export default {
    name: "procedure-quicklink-menu",
    components: {

    },
    data() {
      return {
        menu
      };
    },
    computed: {

    },

    methods: {
      doSomething() {
        this.loadMenu();
        var thisContext = this;
        setTimeout(function () {
          //thisContext.menu[0].expanded = true;
          thisContext.$refs.nestedMenu.setData(thisContext.menu);
        }, 500);

      },
      loadMenu() {
        this.$refs.nestedMenu.setData(this.menu);
      },
      getDefaultSettings() {
        var s = { Property: [] };
        return s;
      },
      doClick(element) {
        this.$emit("onclick", element)
      }

    },
    mounted() {
      this.menu = [
        {
          iconclass: "icon-small icon-plus3",
          orientation: "horizontal",
          direction: "downleft",
          color: "white",
          bgColor: "#ccc",
          elements: [
            {
              option: "settings",
              iconclass: "icon-small icon-cog3",
              tooltip: this.$t('text')
            },
            {
              option: "qr",
              iconclass: "icon-small icon-qrcode",
              tooltip: this.$t('task')
            }
          ]
        }
      ]

      
      this.loadMenu();
      this.$root.$on('procedure_refresh', this.doSomething);
    }
  };

</script>



// WEBPACK FOOTER //
// src/components/procedure/procedure-quicklink-menu.vue